import { Session } from '@ais-ui/auth';

type ValidationResult = {
  errorColumn: number;
  errorLine: number;
  errorMessage: string;
  isValid: boolean;
};

export const validateFilter = async (
  session: Session,
  filterDefinition: string
): Promise<ValidationResult> => {
  const response = await session.request('validateFilter', {
    filterExpression: filterDefinition,
  });

  return response;
};
